import styled, {css} from 'styled-components';

export const Wrapper = styled.div`
    cursor: pointer;
    border: solid 1px black;
    width: 50px;
    padding: 2px;
`;
